import initialState from './initialState';
import {SET_REVIEW} from '../actions/ReviewActions';

export default function ReviewReducer(state = initialState.review, action) {
    switch (action.type) {
        case SET_REVIEW:
            const {data} = action.payload;
            return {...data};
        default:
            return state;
    }
}
